<script setup>
/*==================================================================*/
/*================== VUE IMPORTS ===================================*/
/*==================================================================*/

import { defineProps, defineEmits, useSlots } from 'vue'

/*==================================================================*/
/*================== PROPS =========================================*/
/*==================================================================*/

const props = defineProps({
    value: {
        type: Boolean,
        default: false
    },
    disabled: {
        type: Boolean,
        default: false
    },
    indeterminate: {
        type: Boolean,
        default: false
    },
    color: {
        type: String,
        default: undefined
    },
    dark: {
        type: Boolean,
        default: false
    }
})

/*==================================================================*/
/*================== EMITS =========================================*/
/*==================================================================*/

const emits = defineEmits(['change'])

const slots = useSlots()

/*==================================================================*/
/*================== HANDLERS ======================================*/
/*==================================================================*/

const onChange = (newValue) => {
    
    newValue = newValue ? true : false;

    emits('change', newValue)

}
</script>

<template>

    <div class="c-checkbox">

        <v-checkbox
            class="c-inner-checkbox"
            :input-value="props.value"
            :value="props.value"
            :disabled="props.disabled"
            :indeterminate="props.indeterminate"
            :color="props.color"
            :dark="props.dark"
            hide-details
            @change="onChange($event)"
        ></v-checkbox>

        <div v-if="slots.default" class="c-content">

            <slot></slot>

        </div>

    </div>

</template>

<style scoped>

.c-checkbox{
    display: flex;
    align-items: center;
    gap: 12px;
}

.c-inner-checkbox{
    margin: 0px;
}

.c-inner-checkbox >>> .v-input--selection-controls__input{
    margin-right: 0px;
}

</style>
